/* eslint-disable react-hooks/exhaustive-deps */
import { useAnimationTopUpStore } from "../store";
import { BindHangTags } from "@/components/top-up/types";
import { GPUPlatformList, UserLevel } from "project-config/constants";
import { useGlobalStore } from "@/store/GlobalStore";
import { useEffect } from "react";
import { useQuery } from "react-query";

export function useFetchHangTags() {
  const { setter: setAnimationTopUpStore } = useAnimationTopUpStore();
  const activityInfoList = useAnimationTopUpStore(
    (state) => state.activityInfoList
  );
  const { userInfo } = useGlobalStore();
  const { data } = useQuery<BindHangTags[]>(
    "/api/rendering/user/queryPriceDiscount"
  );
  const fetchHangTags = async () => {
    if (!data || !userInfo) return;
    console.log("queryPriceDiscount:::::", data);
    const res = data?.slice(1);
    const animationFreeze = [5000, 10000, 15000, 20000];
    setAnimationTopUpStore({
      HangTags: res.map((item, index) => ({
        ...item,
        animationNum: animationFreeze[index],
      })),
    });
    if (userInfo && userInfo.level !== UserLevel.Diamond) {
      setAnimationTopUpStore({
        HangTags: res.filter((item) => userInfo.level < item.level),
      });
    }

    const isGPU = GPUPlatformList.includes(userInfo?.platform);
    setAnimationTopUpStore({
      discountName: isGPU ? "gpuDiscount" : "discount",
    });
  };

  useEffect(() => {
    fetchHangTags().catch(console.trace);
  }, [activityInfoList, userInfo, data]);

  return {};
}
